(function () {
  if (window.__bcUiSoundsLoaded) return;
  window.__bcUiSoundsLoaded = true;

  var ctx = null;

  function audioCtx() {
    if (!ctx) {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      ctx = new Ctx();
    }
    return ctx;
  }

  function tone(freq, duration, volume, type) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ac = audioCtx();
    if (!ac) return;
    if (ac.state === 'suspended') {
      ac.resume().catch(function () {});
    }
    var t0 = ac.currentTime;
    var osc = ac.createOscillator();
    var gain = ac.createGain();
    osc.type = type || 'sine';
    osc.frequency.setValueAtTime(freq, t0);
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.exponentialRampToValueAtTime(volume, t0 + 0.004);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
    osc.connect(gain);
    gain.connect(ac.destination);
    osc.start(t0);
    osc.stop(t0 + duration + 0.01);
  }

  function playClick() {
    tone(920, 0.045, 0.07, 'sine');
  }

  function playOpen() {
    tone(740, 0.05, 0.06, 'sine');
    window.setTimeout(function () {
      tone(980, 0.04, 0.05, 'sine');
    }, 38);
  }

  function isSoundTarget(el) {
    if (!el || !el.closest) return false;
    var home = el.closest('.bc-home, [data-bc-root]');
    if (!home) return false;
    return !!el.closest(
      'button, a.bc-btn, [data-bc-open-panel], [data-bc-open-folder], [data-bc-lang-btn], ' +
        '.bc-nav a, .bc-nav-dd-btn, .bc-hub-card, .bc-review-trigger, .bc-score, ' +
        '.bc-folder-nav-btn, .bc-breadcrumb-back, .bc-listing-card, .bc-pro-dir-card, ' +
        '[data-bc-panel-close], .bc-panel-backdrop, .bc-platform, .bc-feature, ' +
        '.bc-search-btn, [data-bc-finish], [data-bc-menu-btn], .bc-mobile-nav a, .bc-dropdown a'
    );
  }

  function soundKind(el) {
    if (
      el.closest(
        '[data-bc-open-panel], [data-bc-open-folder], .bc-review-trigger, .bc-score, ' +
          '[data-bc-panel-close], .bc-panel-backdrop, .bc-breadcrumb-back, [data-bc-back-hub]'
      )
    ) {
      return 'open';
    }
    return 'click';
  }

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!isSoundTarget(target)) return;
      if (soundKind(target) === 'open') {
        playOpen();
      } else {
        playClick();
      }
    },
    true
  );
})();
